import { render, staticRenderFns } from "./MeasuringPoint.vue?vue&type=template&id=0abd3ba9&scoped=true&"
import script from "./MeasuringPoint.vue?vue&type=script&lang=js&"
export * from "./MeasuringPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abd3ba9",
  null
  
)

export default component.exports